export const inputVideoUrlDirective = (InputVideoUrlService) => {
  "ngInject";

  return {
    require: "ngModel",
    restrict: "A",
    link: (scope, element, attrs, ngModel) => {
      ngModel.$validators.inputVideoUrl = (value) => {
        if (value) {
          const videoProvider = InputVideoUrlService.getVideoProvider(value);
          return videoProvider ? true : false;
        }
        return true;
      };
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/common/components/input-video-url/input-video-url.directive.js